// @ts-nocheck
import React, { useState, ChangeEvent, useEffect } from 'react';
import _ from 'lodash';
import {
  Box,
  Typography,
  TextField,
  Button,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Switch,
  Select,
  Modal,
  Divider,
  InputAdornment,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Checkbox,
  MenuItem,
  SelectChangeEvent,
  Tooltip,
  Card,
  useMediaQuery,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
// import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AddIcon from '@mui/icons-material/Add';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RemoveIcon from '@mui/icons-material/Remove';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { useAppDispatch, useAppSelector } from '../../shared/hooks';
import { fetchCompletion, updateCompletion, removeCompletion, downloadFileThunk } from './CompletionSlice';
import { getUsersThunk, clearUsersState } from '../users/usersSlice';
import { getGridRequest } from '../../shared/utils';
// import {
//   fetchSios,
// } from '../sio/sioSlice';
import { Vocabulary, Locations } from '../../shared/interfaces/program/program';
import '../sio/Sio.scss';
import { completionAction, sendEmail } from '../../api/portal/completionRequest';
import { getLocations, getVocab } from '../../api/portal/programRequest';
import { CellPhoneInput } from '../../shared/components';
import info from '../../assets/svg/Union.svg';
import close from '../../assets/svg/closeIcon.svg';
import fonts from '../../assets/scss/font.module.scss';
import colors from '../../assets/scss/color.module.scss';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: '#FFFFFF',
  border: '1px solid #E6E6E6',
  boxShadow: 24,
  borderRadius: 5,
};

const successStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: '#FFFFFF',
  width: '40vw',
  border: '1px solid #E6E6E6',
  boxShadow: 24,
  borderRadius: 5,
  padding: '30px 50px',
};

interface CompletionData {
  id: string;
}

const lifetimeOutputForm = [{ quantity: 0, description: '' }];

interface LocationState {
  isCreate: string;
}

const CompletionDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const isCreate = location.state as LocationState;
  const accountId = useAppSelector((state) => state.app.account?.id!);
  const completionState = useAppSelector((state) => state.completion);
  const instance = useAppSelector((state) => state.app.associatedInstance);
  const [openModal, setOpenModal] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openSuccessModal, setOpenSuccessModal] = React.useState(false);
  const [openApprovedModal, setOpenApprovedModal] = React.useState('');
  const { completion } = completionState;
  const success = useAppSelector((state) => state.editUser.success);
  const usersState = useAppSelector((state) => state.users);
  const dispatch = useAppDispatch();
  const { grid, active } = usersState;
  const { page, pageSize, sort, filter } = grid;
  const navigate = useNavigate();
  const [completionFormName, setCompletionFormName] = useState('');
  const [sioName, setSioName] = useState('');
  const [dueDate, setDueDate] = useState(completion.dueDate);
  const [siAdmin, setSiAdmin] = useState(completion.siAdmin);
  const [edit, setEdit] = useState(false);
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const { general } = completion;
  const [fundingFormName, setFundingFormName] = useState(completion.fundingFormName);
  const [locations, setLocations] = useState<Locations>();
  const [fundingAmount, setFundingAmount] = useState('');
  const [fundingCurrency, setFundingCurrency] = useState('');
  const [notes, setNotes] = useState('');
  const [vocab, setVocab] = useState<Vocabulary>();
  const [, setFiles] = useState<File>();
  const initialFormValue = {
    causes: completion?.impactAndScope?.causes ?? [],
    primaryImpact: completion?.impactAndScope?.primaryImpact ?? [],
    secondaryImpact: completion?.impactAndScope?.secondaryImpacts ?? [],
    targetGroup: completion?.impactAndScope?.targetGroup ?? [],
    audienceAge: completion?.impactAndScope?.audienceAge ?? [],
    strategies: completion?.strategiesAndApproaches?.strategies ?? [],
    dataMeasurementType: completion?.strategiesAndApproaches?.dataMeasurementType,
    approachDuration: completion?.strategiesAndApproaches?.approachDuration,
    evidenceDescription: completion?.researchAndEvaluation?.evidenceDescription?.selected ?? [],
    studyDescription: completion?.researchAndEvaluation?.studyDescription?.selected ?? [],
    dataDescription: completion?.researchAndEvaluation?.dataDescription?.selected ?? [],
    researchApproach: completion?.researchAndEvaluation?.researchApproach ?? [],
    strength: completion?.researchAndEvaluation?.strength,
    outcomeDescription: completion?.researchAndEvaluation?.outcomeDescription ?? [],
    outputs: lifetimeOutputForm,
    outcomes: lifetimeOutputForm,
    regions: completion?.impactAndScope?.locationDetails?.regions ?? [],
    countries: completion?.impactAndScope?.locationDetails?.countries ?? [],
    states: completion?.impactAndScope?.locationDetails?.states ?? [],
    cities: completion?.impactAndScope?.locationDetails?.cities ?? [],
    additionalLocationDetails:
      completion?.impactAndScope?.locationDetails?.additionalLocationDetails,
    environmentalOutputValues: lifetimeOutputForm,
    environmentalOutputs: completion?.researchAndEvaluation?.environmentalOutputs?.selected ?? [],
    activities: completion?.strategiesAndApproaches?.activities?.value,
    activitiesFrequency: completion?.strategiesAndApproaches?.activitiesFrequency,
    nonprofitPartners: completion?.strategiesAndApproaches?.nonprofitPartners ?? false,
    nonprofitPartnersDescription:completion?.strategiesAndApproaches?.nonprofitPartnersDescription??'',
    researchFile: completion?.researchAndEvaluation?.researchFile,
    phone: completion?.general?.contact?.phone,
    locationExplanation: {
      regions: completion?.impactAndScope?.locationDetails?.locationExplanation?.regions ?? '',
      countries: completion?.impactAndScope?.locationDetails?.locationExplanation?.countries ?? '',
      states: completion?.impactAndScope?.locationDetails?.locationExplanation?.states ?? '',
      cities: completion?.impactAndScope?.locationDetails?.locationExplanation?.cities ?? '',
    },
  };

  const [formValues, setFormValues] = useState(initialFormValue);
  const is1024 = useMediaQuery('(max-width:1024px)');
  const [isShown, setIsShown] = useState(true);

  const commonTextStyle = {
    heading: {
      fontSize: fonts.fontSize18,
      fontWeight: fonts.fontWeight600,
      color: colors.textPrimary,
    },
    subHeading: {
      fontSize: fonts.fontSize16,
      fontWeight: fonts.fontWeight400,
      color: colors.textPrimary,
    },
    buttonStyle: {
      border: `1px solid ${colors.primary}`,
      color: colors.primary,
      fontSize: fonts.fontSize14,
      fntWeight: fonts.fontWeight700,
    },
    questionStyle: {
      fontSize: fonts.fontSize14,
      fontWeight: fonts.fontWeight400,
    },
    cancelSaveBtn: {
      border: `1px solid ${colors.primary}`,
      color: colors.primary,
      fontSize: fonts.fontSize14,
      fntWeight: fonts.fontWeight700,
      marginTop: '1em',
    },
    sup: {
      color: colors.statusAlert,
      fontSize: fonts.fontSize18,
      fontWeight: fonts.fontWeight500,
      marginLeft: '3px',
    },
    labelStyle: {
      fontSize: fonts.fontSize16,
      fontWeight: fonts.fontWeight600,
      marinBottom: '3px',
      color: colors.textPrimary,
    },
    textFieldStyle: {
      height: '41px !important',
      borderRadius: '5px',
      '& .MuiOutlinedInput-root .MuiOutlinedInput-input': {
        padding: '11px 10px',
        fontSize: fonts.fontSize14,
        fontWeight: fonts.fntWeight400,
      }
    },
    textAreaStyle: {
        '& .MuiOutlinedInput-root .MuiOutlinedInput-input': {
            fontSize: fonts.fontSize14,
            fontWeight: fonts.fntWeight400,
        }
    },
    accordionStyle: {
      fontSize: fonts.fontSize24,
      fontWeight: fonts.fontWeight600,
      color: colors.textPrimary,
    },
    accordionCount: {
      fontSize: fonts.fontSize18,
      fontWeight: fonts.fontWeight600,
      color: colors.textSecondary,
    },
    accordionButton: {
      border: `1px solid ${colors.strokeClick}`, 
      width: '44px', 
      height: '44px', 
      display: 'flex', 
      borderRadius: '5px',
      justifyContent: 'center', 
      alignItems: 'center',
    }
  }

  const handleClick = () => {
    setIsShown(false);
  };

  const downloadFile = (file: any) => {
    if (_.has(file, 'url')) {
      dispatch(downloadFileThunk({ id, url: file.url }))
      .then(() => {
        toast.success('File downloaded successfully');
      })
    } else {
      toast.error('Unable to fetch file url');
    }
  };

  const downloadTextButton = (file: any) => (
    <Box
    sx={(theme) => ({
      color: theme.palette.success.dark,
      textDecoration: 'underline',
      lineHeight: '23.8px',
      fontWeight: 400,
      fontSize: '14px',
      cursor: 'pointer',
      marginLeft: '8px',
      display: 'flex',
      alignItems: 'center' })}
      onClick={() => downloadFile(file)}
    >Download file</Box>
  );

  const updatedGrid = {
    ...grid,
    pageSize: 1000,
    defaultSort: { field: 'roles', direction: 'asc' as const },
    filter: { field: 'roles', simpleValue: 'sw_si_admin' },
  };
  const getUsersGridRequest = () => ({
    ...getGridRequest(updatedGrid),
    accountId,
  });

  const Roles = grid.data.results;
  const SiAdminRoles = Roles.filter((arr) => (arr.roles ? arr.roles.includes('sw_si_admin') : ''));

  const selectSIOptions = SiAdminRoles.map((option) => (
    <MenuItem key={option.id} value={option.id}>
      {`${option.firstName} ${option.lastName}`}
    </MenuItem>
  ));

  useEffect(() => {
    if (id) {
      dispatch(fetchCompletion(id)).then((CompletionData: any) => {
        setCompletionFormName(CompletionData.payload.completionFormName);
        setSioName(CompletionData.payload.sioName);
        setSiAdmin(CompletionData.payload.siAdmin);
        setEdit(CompletionData.payload.editing);
        // setProgram(CompletionData.payload.general.programName.platformProgramName)
        setFundingFormName(CompletionData.payload.fundingFormName);
        // setSeller(CompletionData.payload.scalewithCustomer)
        // setBuyer(CompletionData.payload.client)
        setFundingAmount(CompletionData.payload.fundingAmount);
        setFundingCurrency(CompletionData.payload.fundingCurrency);
        setNotes(CompletionData.payload.notes);
        setDueDate(CompletionData.payload.dueDate);
        setFormValues({
          causes: CompletionData.payload?.impactAndScope?.causes ?? [],
          primaryImpact: CompletionData.payload?.impactAndScope?.primaryImpact ?? [],
          secondaryImpact: CompletionData.payload?.impactAndScope?.secondaryImpacts ?? [],
          targetGroup: CompletionData.payload?.impactAndScope?.targetGroup ?? [],
          audienceAge: CompletionData.payload?.impactAndScope?.audienceAge ?? [],
          strategies: CompletionData.payload?.strategiesAndApproaches?.strategies ?? [],
          dataMeasurementType: CompletionData.payload?.strategiesAndApproaches?.dataMeasurementType,
          approachDuration: CompletionData.payload?.strategiesAndApproaches?.approachDuration,
          evidenceDescription:
            CompletionData.payload?.researchAndEvaluation?.evidenceDescription?.selected ?? [],
          studyDescription:
            CompletionData.payload?.researchAndEvaluation?.studyDescription?.selected ?? [],
          dataDescription:
            CompletionData.payload?.researchAndEvaluation?.dataDescription?.selected ?? [],
          researchApproach: CompletionData.payload?.researchAndEvaluation?.researchApproach ?? [],
          strength: CompletionData.payload?.researchAndEvaluation?.strength,
          outcomeDescription:
            CompletionData.payload?.researchAndEvaluation?.outcomeDescription ?? [],
          outputs: CompletionData.payload?.strategiesAndApproaches?.outputs ?? lifetimeOutputForm,
          outcomes: CompletionData.payload?.strategiesAndApproaches?.outcomes ?? lifetimeOutputForm,
          regions: CompletionData.payload?.impactAndScope?.locationDetails?.regions ?? [],
          countries: CompletionData.payload?.impactAndScope?.locationDetails?.countries ?? [],
          states: CompletionData.payload?.impactAndScope?.locationDetails?.states ?? [],
          cities: CompletionData.payload?.impactAndScope?.locationDetails?.cities ?? [],
          additionalLocationDetails:
            CompletionData.payload?.impactAndScope?.locationDetails?.additionalLocationDetails,
          environmentalOutputs:
            CompletionData.payload?.researchAndEvaluation?.environmentalOutputs?.selected ?? [],
          activities: CompletionData.payload?.strategiesAndApproaches?.activities?.value,
          activitiesFrequency: CompletionData.payload?.strategiesAndApproaches?.activitiesFrequency,
          environmentalOutputValues:
            CompletionData.payload?.researchAndEvaluation?.environmentalOutputValues ??
            lifetimeOutputForm,
          nonprofitPartners:
            CompletionData.payload?.strategiesAndApproaches?.nonprofitPartners ?? false,
            nonprofitPartnersDescription:CompletionData?.payload?.strategiesAndApproaches?.nonprofitPartnersDescription ??'',
          researchFile: CompletionData.payload?.researchAndEvaluation?.researchFile,
          phone: CompletionData.payload?.general?.contact?.phone,
          locationExplanation: {
            regions:
              CompletionData.payload?.impactAndScope?.locationDetails?.locationExplanation
                ?.regions ?? '',
            countries:
              CompletionData.payload?.impactAndScope?.locationDetails?.locationExplanation
                ?.countries ?? '',
            states:
              CompletionData.payload?.impactAndScope?.locationDetails?.locationExplanation
                ?.states ?? '',
            cities:
              CompletionData.payload?.impactAndScope?.locationDetails?.locationExplanation
                ?.cities ?? '',
          },
        });
      });
      getVocab().then((res) => {
        if (res.status === 200) {
          setVocab(res.data);
        }
      });
      getLocations().then((res) => {
        if (res.status === 200) {
          setLocations(res.data);
        }
      });
    }
  }, [id]);

  // useEffect(() => {
  //   if (updateStatusSuccess) toast.success('New Completion Form created Successfully');
  // }, [updateStatusSuccess]);

  useEffect(() => {
    dispatch(getUsersThunk({ active, ...getUsersGridRequest() }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sort, filter, page, pageSize, active]);

  useEffect(() => {
    if (success) dispatch(getUsersThunk({ active, ...getUsersGridRequest() }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const getCurrencySymbol = (code: string) => {
    switch (code) {
      case 'USD':
        return '$';
      case 'EUR':
        return '€';
      case 'GBP':
        return '£';
      // Add more cases for other currency codes as needed
      default:
        return '$';
    }
  };

  const sumQuantity = completion.funding.itemization.value.reduce(
    (sum, item) => sum + item.quantity,
    0,
  );

  useEffect(
    () => () => {
      dispatch(clearUsersState());
    },
    [dispatch],
  );
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target as HTMLInputElement;
    setFormValues({ ...formValues, [name]: value });
    if (name === 'completionFormName') {
      setCompletionFormName(value);
    }
    if (name === 'notes') {
      setNotes(value);
    }
  };
  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target as HTMLInputElement;
    // setFormValues({ ...formValues, [name]: value });
    // if (name === "sio") {
    //   setSio(value);
    // }
    if (name === 'siAdmin') {
      setSiAdmin(value);
    }
  };

  const handleOutputChange =
    (field: string, index: number, name: string) => (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      if (name === 'outputs') {
        const newLifetimeOutputs = [...formValues.outputs];
        newLifetimeOutputs[index] = { ...newLifetimeOutputs[index], [field]: value };
        setFormValues((prevValues) => ({
          ...prevValues,
          outputs: newLifetimeOutputs,
        }));
      } else {
        const newLifetimeOutputs = [...formValues.outcomes];
        newLifetimeOutputs[index] = { ...newLifetimeOutputs[index], [field]: value };
        setFormValues((prevValues) => ({
          ...prevValues,
          outcomes: newLifetimeOutputs,
        }));
      }
    };

  const handleChangeSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name === 'causes') {
      let newvalue = formValues.causes;
      if (newvalue.includes(value)) {
        newvalue = newvalue.filter((item) => value !== item);
      } else if (formValues.causes.length <= 1) {
        newvalue = [...newvalue, value];
      }
      setFormValues({
        ...formValues,
        causes: newvalue,
      });
    }
    if (name === 'secondaryImpact') {
      let newvalue = formValues.secondaryImpact;
      if (newvalue.includes(value)) {
        newvalue = newvalue.filter((item) => value !== item);
      } else if (formValues.secondaryImpact.length < 3) {
        newvalue = [...newvalue, value];
      }
      setFormValues({
        ...formValues,
        secondaryImpact: newvalue,
      });
    }
    if (name === 'targetGroup') {
      let newvalue = formValues.targetGroup;
      if (newvalue.includes(value)) {
        newvalue = newvalue.filter((item) => value !== item);
      } else {
        newvalue = [...newvalue, value];
      }
      setFormValues({
        ...formValues,
        targetGroup: newvalue,
      });
    }
    if (name === 'audienceAge') {
      let newvalue = formValues.audienceAge;
      if (newvalue.includes(value)) {
        newvalue = newvalue.filter((item) => value !== item);
      } else {
        newvalue = [...newvalue, value];
      }
      setFormValues({
        ...formValues,
        audienceAge: newvalue,
      });
    }
    if (name === 'regions') {
      if (value === 'N/A') {
        setFormValues({
          ...formValues,
          regions: ['N/A'],
        });
      } else {
        let newvalue = formValues.regions;
        if (newvalue.includes('N/A')) {
          newvalue = [];
        }
        if (newvalue.includes(value)) {
          newvalue = newvalue.filter((item) => value !== item);
        } else {
          newvalue = [...newvalue, value];
        }
        setFormValues({
          ...formValues,
          regions: newvalue,
        });
      }
    }
    if (name === 'countries') {
      if (value === 'N/A') {
        setFormValues({
          ...formValues,
          countries: ['N/A'],
        });
      } else {
        let newvalue = formValues.countries;
        if (newvalue.includes('N/A')) {
          newvalue = [];
        }
        if (newvalue.includes(value)) {
          newvalue = newvalue.filter((item) => value !== item);
        } else {
          newvalue = [...newvalue, value];
        }
        setFormValues({
          ...formValues,
          countries: newvalue,
        });
      }
    }
    if (name === 'states') {
      if (value === 'N/A') {
        setFormValues({
          ...formValues,
          states: ['N/A'],
        });
      } else {
        let newvalue = formValues.states;
        if (newvalue.includes('N/A')) {
          newvalue = [];
        }
        if (newvalue.includes(value)) {
          newvalue = newvalue.filter((item) => value !== item);
        } else {
          newvalue = [...newvalue, value];
        }
        setFormValues({
          ...formValues,
          states: newvalue,
        });
      }
    }
    if (name === 'cities') {
      if (value === 'N/A') {
        setFormValues({
          ...formValues,
          cities: ['N/A'],
        });
      } else {
        let newvalue = formValues.cities;
        if (newvalue.includes('N/A')) {
          newvalue = [];
        }
        if (newvalue.includes(value)) {
          newvalue = newvalue.filter((item) => value !== item);
        } else {
          newvalue = [...newvalue, value];
        }
        setFormValues({
          ...formValues,
          cities: newvalue,
        });
      }
    }
    if (name === 'strategies') {
      let newvalue = formValues.strategies;
      if (newvalue.includes(value)) {
        newvalue = newvalue.filter((item) => value !== item);
      } else {
        newvalue = [...newvalue, value];
      }
      setFormValues({
        ...formValues,
        strategies: newvalue,
      });
    }
    if (name === 'evidenceDescription') {
      let newvalue = formValues.evidenceDescription;
      if (newvalue.includes(value)) {
        newvalue = newvalue.filter((item) => value !== item);
      } else {
        newvalue = [...newvalue, value];
      }
      setFormValues({
        ...formValues,
        evidenceDescription: newvalue,
      });
    }
    if (name === 'studyDescription') {
      let newvalue = formValues.studyDescription;
      if (newvalue.includes(value)) {
        newvalue = newvalue.filter((item) => value !== item);
      } else {
        newvalue = [...newvalue, value];
      }
      setFormValues({
        ...formValues,
        studyDescription: newvalue,
      });
    }
    if (name === 'dataDescription') {
      let newvalue = formValues.dataDescription;
      if (newvalue.includes(value)) {
        newvalue = newvalue.filter((item) => value !== item);
      } else {
        newvalue = [...newvalue, value];
      }
      setFormValues({
        ...formValues,
        dataDescription: newvalue,
      });
    }
    if (name === 'outcomeDescription') {
      let newvalue = formValues.outcomeDescription;
      if (newvalue.includes(value)) {
        newvalue = newvalue.filter((item) => value !== item);
      } else {
        newvalue = [...newvalue, value];
      }
      setFormValues({
        ...formValues,
        outcomeDescription: newvalue,
      });
    }
    if (name === 'researchApproach') {
      let newvalue = formValues.researchApproach;
      if (newvalue.includes(value)) {
        newvalue = newvalue.filter((item) => value !== item);
      } else if (formValues.researchApproach.length < 3) {
        newvalue = [...newvalue, value];
      }
      setFormValues({
        ...formValues,
        researchApproach: newvalue,
      });
    }
    if (name === "environmentalOutputs") {
      let newvalue = formValues.environmentalOutputs;
      let newOutputValues=[...formValues.environmentalOutputValues]
      const label:any=vocab?.sccConversion?.filter((voc:any)=>voc?._id===value)
      const index = formValues?.environmentalOutputs?.indexOf(value);
      if (newvalue.includes(value)) {
        newvalue = newvalue.filter(item => value !== item)
               newOutputValues?.splice(index,1)
      } else  {
        newvalue = [...newvalue, value]
        newOutputValues=[...newOutputValues,{quantity:0,description:label[0]?.label}]
      }
      setFormValues({
        ...formValues,
        environmentalOutputs: newvalue,
        environmentalOutputValues:newOutputValues
      });
    }
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    const NUMERIC_DASH_REGEX = /^[0-9-]+$/;
    if (name === 'phone') {
      if (NUMERIC_DASH_REGEX.test(value)) {
        setFormValues({ ...formValues, [name]: value });
      }
    } else if (name === 'nonprofitPartners') {
      if (value === 'yes') {
        setFormValues({ ...formValues, [name]: true });
      } else {
        setFormValues({ ...formValues, [name]: false,nonprofitPartnersDescription:'' });
      }
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  const isChecked1 = (value: string) => {
    let returnValue = false;
    formValues.researchApproach.map((item: any) => {
      if (item._id === value) returnValue = true;
      return true;
    });
    return returnValue;
  };

  const isChecked = (data: any, value: string) => {
    let returnValue = false;
    data.map((item: any) => {
      const n = item.lastIndexOf(';');
      const result = item.substring(n + 1);
      if (result === value) {
        returnValue = true;
      }
      return null;
    });
    return returnValue;
  };

  const handleSubmit = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const data = {
      completion: {
        completionFormName,
        siAdmin,
        editing: edit,
        notes,
        dueDate,
      },
      id: completion.id,
    };
    const newCompletion: CompletionData = (await dispatch(updateCompletion(data)))
      .payload as CompletionData;
    console.log('newCompletion', newCompletion);
    if (newCompletion?.id) {
      toast.success('Completion updated Successfully');
      navigate(`/app/completions/${newCompletion.id}`);
    }
  };

  const handleOpenModal = (type: string) => {
    if (type === 'delete') {
      setOpenDeleteModal(true);
    } else {
      setOpenModal(true);
    }
  };

  const handleUpload = (e: ChangeEvent<HTMLInputElement>) => {
    const fileList = e.target.files;
    if (!fileList) return;
    setFiles(fileList[0]);
  };

  const getFieldValue = (indexNumber: number, field: string) => {
    let value;
    formValues?.environmentalOutputValues?.map((item, index) => {
      if (index === indexNumber) {
        if (field === 'quantity') {
          value = item.quantity;
        }
        if (field === 'description') {
          value = item.description;
        }
      }
      return 1;
    });
    return value;
  };

  const handleAccordion = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSendForm = async () => {
    const data = {
      sio_form_link: `${instance?.settings?.portalUrl}/completion-form/${id}`,
    };
    if (id) sendEmail(id, data).then(() => setOpenSuccessModal(true));
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setOpenDeleteModal(false);
    setOpenApprovedModal('');
  };

  const handleCloseSuccessModal = () => {
    setOpenSuccessModal(false);
    navigate('/app/completions');
  };

  const handleCancelCompletion = () => {
    toast.success('Completion Form cancelled successfully');
    navigate('/app/completions');
  };

  const handleApprovedAction = async (action: string) => {
    const response = await completionAction(completion.id, action.toLocaleLowerCase());
    if (response) {
      if (action === 'Rejected') {
        navigate('/app/completions');
        toast.success('Completion Rejected Successfully');
      }

      if (action === 'Approved') {
        handleCloseModal();
        dispatch(fetchCompletion(completion.id));
        toast.success(`Completion form ${action.toLocaleLowerCase()} successfully`);
      } else {
        handleCloseModal();
        navigate('/app/completions');
        toast.success(`Completion form ${action.toLocaleLowerCase()} successfully`);
      }
    }
  };

  const handleLifetimeOutputChange = (field: string, index: number, value:any,lifetimeOutput:any)  => {
    const newLifetimeOutputs = [...formValues.environmentalOutputValues!];
    const label:any=vocab?.sccConversion?.filter((item:any)=>item?._id===lifetimeOutput)
    newLifetimeOutputs[index] = { ...newLifetimeOutputs[index],[field]: value,description:label&& label[0]?.label };
    if (Number(value) >= 0) {
      setFormValues((prevValues) => ({
        ...prevValues,
        environmentalOutputValues: newLifetimeOutputs,
      }));
    }
  };
  const renderCountriesOptions = (country: any) =>
    country[0][1]?.map((items: any) => (
      <Box
        key={items.name}
        className={isChecked(formValues.countries, items.name) ? 'active' : ''}
        sx={{
          border: '1px solid #E0E0E0',
          display: 'inline-block',
          width: 'fit-content',
          m: 1,
          borderRadius: '20px',
          p: 2,
          fontSize: fonts.fontSize14,
          fontWeight: fonts.fontWeight400
        }}
      >
        <Typography variant="body1" display="inline">
          {items.name}
        </Typography>
        <Checkbox
          disabled
          name="countries"
          checked={isChecked(formValues.countries, items.name)}
          value={items.name}
          onChange={handleChangeSelect}
        />
      </Box>
    ));

  const renderCitiesOptions = (country: any) =>
    country.length > 0 &&
    country[0][1]?.map((items: any) => (
      <Box
        key={items.name}
        className={isChecked(formValues.cities, items.name) ? 'active' : ''}
        sx={{
          border: '1px solid #E0E0E0',
          display: 'inline-block',
          width: 'fit-content',
          m: 1,
          borderRadius: '20px',
          p: 2,
          fontSize: fonts.fontSize14,
          fontWeight: fonts.fontWeight400
        }}
      >
        <Typography variant="body1" display="inline">
          {items.name}
        </Typography>
        <Checkbox
          disabled
          name="cities"
          checked={isChecked(formValues.cities, items.name)}
          value={items.name}
          onChange={handleChangeSelect}
        />
      </Box>
    ));

  const renderstatesOptions = (country: any) =>
    country.length > 0 &&
    country[0][1]?.map((items: any) => (
      <Box
        key={items.name}
        className={isChecked(formValues.states, items.name) ? 'active' : ''}
        sx={{
          border: '1px solid #E0E0E0',
          display: 'inline-block',
          width: 'fit-content',
          m: 1,
          borderRadius: '20px',
          p: 2,
          fontSize: fonts.fontSize14,
          fontWeight: fonts.fontWeight400
        }}
      >
        <Typography variant="body1" display="inline">
          {items.name}
        </Typography>
        <Checkbox
          disabled
          name="states"
          checked={isChecked(formValues.states, items.name)}
          value={items.name}
          onChange={handleChangeSelect}
        />
      </Box>
    ));

  const renderCountries = (region: string) => {
    const regions = Object.entries(locations!.countries);
    let countries: any = [];
    if (region !== 'N/A') {
      countries = regions.filter((item) => item[0] === region ?? item);
      return renderCountriesOptions(countries);
    }
    return true;
  };

  const renderStates = (region: string) => {
    const regions = Object.entries(locations!.states);
    let countries: any = [];
    if (region === 'United States' || region === 'Canada' || region !== 'N/A') {
      countries = regions.filter((item) => item[0] === region ?? item);
      return renderstatesOptions(countries);
    }
    return true;
  };

  const renderCities = (region: string) => {
    const regions = Object.entries(locations!.cities);
    let countries: any = [];
    if (region !== 'United States' && region !== 'Canada' && region !== 'N/A') {
      countries = regions.filter((item) => item[0] === region ?? item);
      return renderCitiesOptions(countries);
    }
    return true;
  };

  const renderButtons = () => {
    let buttons;
    if (completion.status === 'submitted') {
      buttons = (
        <>
          <Button
            onClick={() => setOpenApprovedModal('Archived')}
            sx={{ ml: 3 }}
            variant="outlined"
            size="large"
            color="primary"
          >
            Archive
          </Button>
          <Button
            onClick={() => setOpenApprovedModal('Rejected')}
            sx={{ ml: 3 }}
            variant="outlined"
            size="large"
            color="error"
          >
            Reject
          </Button>
          <Button
            onClick={() => setOpenApprovedModal('Approved')}
            sx={{ ml: 3 }}
            variant="contained"
            size="large"
            color="primary"
          >
            Approve
          </Button>
        </>
      );
    } else if (isCreate) {
      buttons = (
        <>
          <Button
            onClick={handleSendForm}
            sx={{ float: 'right', ml: 3 }}
            variant="contained"
            size="large"
            color="primary"
          >
            Send Form
          </Button>
          <Button
            onClick={() => handleOpenModal('cancel')}
            sx={{ float: 'right' }}
            variant="outlined"
            size="large"
            color="primary"
          >
            Cancel
          </Button>
        </>
      );
    } else {
      buttons = (
        <Button
          onClick={() => handleOpenModal('delete')}
          sx={{ float: 'right' }}
          variant="outlined"
          size="large"
          color="error"
        >
          Delete Completion Form
        </Button>
      );
    }

    return buttons;
  };

  const StatusBadge = (status: String) => {
    let data;
    switch (status) {
      case 'in_progress':
        data = (
          <>
            <HourglassEmptyIcon fontSize="small" sx={{ marginRight: '10px' }} />
            <Typography
              sx={{ display: 'inline-block', position: 'relative', textTransform: 'capitalize' }}
              variant="button"
            >
              In Progress {completion.percentComplete}%
            </Typography>
          </>
        );

        break;
      case 'approved':
        data = (
          <>
            <CheckCircleOutlineIcon sx={{ marginRight: '10px' }}/>
            <Typography
              sx={{ display: 'inline-block', position: 'relative', textTransform: 'capitalize' }}
              variant="button"
            >
              Approved
            </Typography>
          </>
        );

        break;
      case 'submitted':
        data = (
          <>
            <AccessTimeIcon sx={{ marginRight: '10px' }}/>
            <Typography
              sx={{ display: 'inline-block', position: 'relative', textTransform: 'capitalize' }}
              variant="button"
            >
              Submitted
            </Typography>
          </>
        );
        break;
      default:
    }
    return data;
  };

  const handleDeleteCompletion = () => {
    if (id) dispatch(removeCompletion(id));
    toast.success('Completion form deleted Successfully');
    navigate('/app/completions');
  };

  return (
    <>
      {/* approve, archive and reject modal */}
      <Modal
        open={openApprovedModal !== ''}
        onClose={handleCloseModal}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style }}>
          <Grid container>
            <Grid
              item
              xs={12}
              sx={{
                bgcolor: `${openApprovedModal === 'Rejected' ? '#FDE3E3' : 'rgba(0,95,234,0.2)'}`,
                mb: 2,
                p: 2,
                borderRadius: '20px 20px 0 0',
              }}
            >
              <Typography
                variant="h5"
                color={openApprovedModal === 'Rejected' ? 'error' : 'primary'}
              >
                {`${openApprovedModal} Confirmation`}
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ p: 2 }}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Are you sure you want to {openApprovedModal === 'Approved' && 'approve'}
                {openApprovedModal === 'Archived' && 'archive'}
                {openApprovedModal === 'Rejected' && 'reject'} Completion Application for &quot;
                {completion.completionFormName}&quot;
              </Typography>
            </Grid>
            <Grid item xs={12} textAlign="right" sx={{ p: 2, borderTop: '1px solid #E6E6E6' }}>
              <Button
                onClick={handleCloseModal}
                sx={{ ml: 3 }}
                variant="outlined"
                size="large"
                color="primary"
              >
                Cancel
              </Button>
              <Button
                onClick={() => handleApprovedAction(openApprovedModal)}
                sx={{ ml: 3 }}
                variant="contained"
                size="large"
                color={openApprovedModal === 'Rejected' ? 'error' : 'primary'}
              >
                {openApprovedModal}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {/* delete and cancel modal */}
      <Modal
        open={openModal || openDeleteModal}
        onClose={handleCloseModal}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style }}>
          <Grid container>
            <Grid
              item
              xs={12}
              sx={{
                bgcolor: `${openDeleteModal ? '#FDE3E3' : 'rgba(0,95,234,0.2)'}`,
                mb: 2,
                p: 2,
                borderRadius: '20px 20px 0 0',
              }}
            >
              <Typography variant="h5" color={openDeleteModal ? 'error' : 'primary'}>
                {openDeleteModal ? 'Delete Confirmation' : 'Cancel Confirmation'}
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ p: 2 }}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Are you sure you want to {openDeleteModal ? 'delete this' : 'cancel'}?
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {openDeleteModal
                  ? 'Deleting this record cannot be undone and all associated data will be permanently removed. Please confirm that you wish to proceed with the deletion.'
                  : 'Cancelling this process will redirect you to Completion Dashboard Page. Any unsaved data record will be lost permanently.'}
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ p: 2, borderTop: '1px solid #E6E6E6' }}>
              {openDeleteModal ? (
                <>
                  <Button
                    onClick={handleDeleteCompletion}
                    sx={{ float: 'right', ml: 3 }}
                    variant="contained"
                    size="large"
                    color="error"
                  >
                    Delete Completion Form
                  </Button>
                  <Button
                    onClick={handleCloseModal}
                    sx={{ float: 'right', ml: 3 }}
                    variant={openDeleteModal ? 'outlined' : 'contained'}
                    size="large"
                    color="primary"
                  >
                    Cancel
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    onClick={handleCloseModal}
                    sx={{ float: 'right', ml: 3 }}
                    variant="outlined"
                    size="large"
                    color="primary"
                  >
                    Stay
                  </Button>
                  <Button
                    onClick={handleCancelCompletion}
                    sx={{ float: 'right', ml: 3 }}
                    variant={openDeleteModal ? 'outlined' : 'contained'}
                    size="large"
                    color="primary"
                  >
                    Cancel
                  </Button>
                </>
              )}
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={openSuccessModal}
        onClose={handleCloseSuccessModal}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...successStyle }}>
          <Grid container>
            <Grid item xs={12} sx={{ textAlign: 'center' }}>
              <CloseIcon
                onClick={handleCloseSuccessModal}
                fontSize="medium"
                sx={{ position: 'absolute', right: '20px', top: '20px' }}
              />
              <CheckCircleOutlineIcon fontSize="large" color="success" />
              <Typography variant="h5" sx={{ mb: 3 }}>
                Submission Form Shared Successfully!
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                An email with below form link has been sent to your onboarded SIO Users
                successfully!
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ border: '1px solid #c4bebe', borderRadius: '16px', padding: '20px' }}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                      Form Link
                      <Tooltip title="Click to copy URL">
                        <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                      </Tooltip>
                    </Typography>
                    <TextField
                      disabled
                      placeholder="No data yet"
                      fullWidth
                      value={`${instance?.settings?.portalUrl}/completion-form/${id}`}
                      margin="normal"
                      variant="outlined"
                      InputProps={{
                        sx: {
                          '& .MuiInputBase-input::placeholder': {
                            fontSize: '1rem',
                          },
                        },
                      }}
                      sx={{
                        '& .MuiInputBase-root': {
                          height: '50px',
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sx={{ textAlign: 'center', mt: 2 }}>
                    <CopyToClipboard
                      text={`URL: ${instance?.settings?.portalUrl}/completion-form/${id}`}
                      onCopy={() => toast.success('URL Copied Successfully')}
                    >
                      <Button variant="text" color="success">
                        <FileCopyIcon fontSize="small" color="success" /> copy to clipboard
                      </Button>
                    </CopyToClipboard>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Box sx={{ maxWidth: '100%', mx: 'auto', mb: 2, p: 2, borderRadius: '20px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
            <span style={{ fontSize: fonts.fontSize24, fontWeight: fonts.fontWeight700, color: colors.textPrimary }}>
              {completionFormName}
            </span>
            <div
              style={{
                ...(completion.status === 'approved' && {
                  backgroundColor: '#c3fae8',
                  color: '#099268',
                  border: '1px solid #099268',
                }),
                ...(completion.status === 'submitted' && {
                  backgroundColor: '#ffec99',
                  color: '#f08c00',
                  border: '1px solid #f08c00',
                }),
                ...(completion.status === 'in_progress' && {
                  backgroundColor: '#d0ebff',
                  color: '#1864ab',
                  border: '1px solid #313B72',
                }),
                borderRadius: '20px',
                display: 'flex',
                alignItems: 'center',
                height: '27px',
                width: '197px',
                padding: '6px 15px 6px 15px',
                marginLeft: '20px',
                justifyContent: 'center',
              }}
            >
              {StatusBadge(completion.status)}
            </div>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Button
              variant="contained"
              onClick={() => navigate('/app/completions')}
              sx={{ ...commonTextStyle.buttonStyle, backgroundColor: colors.primary, color: colors.secondary, float: 'right' }}
            >
              Back
            </Button>
          </Box>
        </Box>
        {console.log('completion: ', completion)}
        <Box boxShadow={3} sx={{ borderRadius: '20px', bgcolor: 'white' }}>
          <Grid
            container
            spacing={2}
            sx={{
              width: '100%',
              margin: 0,
              border: '1px solid #f1f3f5',
              borderRadius: '20px',
              p: 3,
            }}
          >
            <Grid item xs={12}>
              <Typography sx={{ fontSize: fonts.fontSize24, fntWeight: fonts.fontWeight600, color: colors.textPrimary }}>
                Overview
              </Typography>
            </Grid>
            <Grid
              container
              spacing={3}
              sx={{
                width: '100%',
                margin: 0,
                alignItems: 'flex-end',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Grid item xs={12} sm={4} sx={{ marginBottom: '1rem' }}>
                <Typography sx={commonTextStyle.labelStyle}>
                  Completion Form Name{' '}
                  <Tooltip title="Enter Completion Form Name">
                    <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                  </Tooltip>
                </Typography>
                <TextField
                  name="completionFormName"
                  placeholder="Enter The Completion Form Name"
                  fullWidth
                  value={completionFormName}
                  onChange={handleInputChange}
                  variant="outlined"
                  sx={commonTextStyle.textFieldStyle}
                />
              </Grid>
              <Grid item xs={12} sm={4} sx={{ marginBottom: '1rem' }}>
                <Typography sx={commonTextStyle.labelStyle}>
                  Funding Name{' '}
                  <Tooltip title="Select Funding Name">
                    <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                  </Tooltip>
                </Typography>
                <TextField
                  name="fundingFormName"
                  placeholder="Enter The Funding Form Name"
                  fullWidth
                  value={fundingFormName}
                  disabled
                  // onChange={handleInputChange}
                  variant="outlined"
                  sx={commonTextStyle.textFieldStyle}
                />
              </Grid>
              <Grid item xs={12} sm={4} sx={{ marginBottom: '1rem' }}>
                <Typography sx={commonTextStyle.labelStyle}>
                  Impact Network Partnership Manager{' '}
                  <Tooltip title="Select Impact Network Partnership Manager">
                    <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                  </Tooltip>
                </Typography>
                <FormControl fullWidth>
                  <Select
                    name="siAdmin"
                    labelId="manager-label"
                    placeholder="Impact Network Partnership Manager"
                    value={siAdmin}
                    onChange={handleSelectChange}
                    variant="outlined"
                    sx={{
                      ...commonTextStyle.textFieldStyle,
                      '& .MuiSelect-select': {
                        fontSize: fonts.fontSize14,
                        paddingTop: '26px',
                        height: '100%',
                      },
                    }}
                  >
                    <MenuItem selected value="" disabled>
                      <em>Impact Network Partnership Manager</em>
                    </MenuItem>
                    {selectSIOptions}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4} sx={{ marginBottom: '1rem' }}>
                <Typography sx={commonTextStyle.labelStyle}>
                  Program Selected
                  <Tooltip title="Selected Program Name">
                    <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                  </Tooltip>
                </Typography>
                <TextField
                  name="program"
                  fullWidth
                  value={completion?.general?.programName?.platformProgramName}
                  disabled
                  variant="outlined"
                  sx={commonTextStyle.textFieldStyle}
                />
              </Grid>
              <Grid item xs={12} sm={4} sx={{ marginBottom: '1rem' }}>
                <Typography sx={commonTextStyle.labelStyle}>
                  SIO Name{' '}
                  <Tooltip title="SIO Name">
                    <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                  </Tooltip>
                </Typography>
                <TextField
                  name="sioName"
                  placeholder="SIO name"
                  fullWidth
                  value={sioName}
                  disabled
                  variant="outlined"
                  sx={commonTextStyle.textFieldStyle}
                />
              </Grid>
              <Grid item xs={12} sm={4} sx={{ marginBottom: '1rem' }}>
                <Typography sx={commonTextStyle.labelStyle}>
                  Funding Amount{' '}
                  <Tooltip title="Funding Amount">
                    <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                  </Tooltip>
                </Typography>
                <TextField
                  disabled
                  placeholder="With normal TextField"
                  value={fundingAmount}
                  variant="outlined"
                  size="small"
                  sx={commonTextStyle.textFieldStyle}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Box
                          sx={{
                            backgroundColor: '#C4C4C4',
                            height: '41px',
                            width: '50px',
                            lineHeight: '2',
                            textAlign: 'center',
                            marginLeft: '-14px',
                            '.MuiOutlinedInput-notchedOutline': { border: 0 },
                            'MuiInputBase-adornedStart': { paddingLeft: 0 },
                          }}
                        >
                          {getCurrencySymbol(fundingCurrency)}
                        </Box>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4} sx={{ marginBottom: '1rem', colour: '#C4C4C4' }}>
                <Typography sx={commonTextStyle.labelStyle}>
                  Seller
                  <Tooltip title="Seller Name">
                    <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                  </Tooltip>
                </Typography>
                <TextField
                  name="sellerName"
                  placeholder="Enter The seller Name"
                  fullWidth
                  value={completion?.scalewithCustomer}
                  disabled
                  variant="outlined"
                  sx={commonTextStyle.textFieldStyle}
                />
              </Grid>
              <Grid item xs={12} sm={4} sx={{ marginBottom: '1rem' }}>
                <Typography sx={commonTextStyle.labelStyle}>
                  Buyer
                  <Tooltip title="Buyer Name">
                    <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                  </Tooltip>
                </Typography>
                <TextField
                  name="buyer"
                  placeholder="Buyer Name"
                  fullWidth
                  value={completion?.client}
                  disabled
                  variant="outlined"
                  sx={commonTextStyle.textFieldStyle}
                />
              </Grid>
              <Grid item xs={12} sm={4} textAlign="left" sx={{ marginBottom: '1rem' }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Allow Editing{' '}
                  <Tooltip title="Enable editing">
                    <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                  </Tooltip>
                </Typography>
                <Switch sx={{ mb: 2 }} checked={edit} onClick={() => setEdit(!edit)} />
              </Grid>
              <Grid item xs={12} sm={4} sx={{ marginBottom: '1rem' }}>
                <Typography sx={commonTextStyle.labelStyle}>
                  Submission Form URL{' '}
                  <Tooltip title="Submission Form URL">
                    <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                  </Tooltip>
                </Typography>
                <TextField
                  name="applicationFormName"
                  placeholder="Enter The Submission Form Name"
                  fullWidth
                  disabled
                  value={`${instance?.settings?.portalUrl}/completion-form/${id}`}
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CopyToClipboard
                          text={`${instance?.settings?.portalUrl}/completion-form/${id}`}
                          onCopy={() => toast.success('URL Copied Successfully')}
                        >
                          <FileCopyIcon />
                        </CopyToClipboard>
                      </InputAdornment>
                    ),
                    sx: {
                      '& .MuiInputBase-input::placeholder': {
                        fontSize: '1rem',
                      },
                    },
                  }}
                  sx={commonTextStyle.textFieldStyle}
                />
              </Grid>
              <Grid item xs={12} sm={4} sx={{ marginBottom: '8px' }}>
                <Typography sx={commonTextStyle.labelStyle}>
                  Due Date{' '}
                  <Tooltip title="Enter Due Date">
                    <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                  </Tooltip>
                </Typography>
                <FormControl fullWidth margin="normal">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      renderInput={(props) => (
                        <TextField
                          {...props}
                          variant="outlined"
                          fullWidth
                          defaultValue={dueDate}
                          sx={commonTextStyle.textFieldStyle}
                        />
                      )}
                      value={dueDate}
                      onChange={(date) => setDueDate(date !== null ? date : '')}
                      toolbarPlaceholder="Select Due date"
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4} sx={{ marginBottom: '1rem' }}>
                <Typography sx={commonTextStyle.labelStyle}>
                  Notes
                  <Tooltip title="Enter Notes">
                    <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                  </Tooltip>
                </Typography>
                <TextField
                  name="notes"
                  placeholder="Enter Notes"
                  fullWidth
                  value={notes}
                  onChange={handleInputChange}
                  variant="outlined"
                  sx={commonTextStyle.textFieldStyle}
                />
              </Grid>
              <Grid item xs={12} sx={{ textAlign: 'right', marginBottom: '2rem' }}>
                <Button
                  disabled={!completionFormName || !siAdmin}
                  onClick={handleSubmit}
                  sx={{ ...commonTextStyle.buttonStyle, backgroundColor: colors.primary, color: colors.secondary, ':hover': { backgroundColor: colors.primary, color: colors.secondary } }}
                >
                  Update
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box boxShadow={3} sx={{ bgcolor: 'white', borderRadius: '20px' }}>
          <Grid
            container
            spacing={2}
            sx={{
              width: '100%',
              margin: 0,
              borderRadius: '20px',
              p: 3,
              marginTop: '2rem',
            }}
          >
            <Grid item xs={12} sx={{ marginBottom: '2rem', display: 'flex' }}>
              <Typography sx={{ fontWeight: fonts.fontWeight600, color: colors.textColor, fontSize: fonts.fontSize24 }}>Form Preview</Typography>
              {isShown && (
                <Box
                  sx={{
                    border: '1px solid #004660',
                    borderRadius: '5px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignContent: 'center',
                    gap: '10px',
                    marginLeft: '20px',
                    backgroundColor: colors.backgroundSecondary,
                  }}
                >
                  <img
                    style={{ marginLeft: '15px', marginTop: `${is1024 ? '10px' : 'auto'}` }}
                    src={info}
                    alt="info icon"
                    width="24px"
                    height="24px"
                  />
                  <Typography
                    sx={{
                      fontSize: fonts.fontSize14,
                      fontWeight: fonts.fontWeight600,
                      color: colors.textPrimary,
                      width: `${is1024 ? '410px' : 'auto'}`,
                    }}
                  >
                    Please Note: Below information is the read only preview of the form that your
                    SIO users will receive.
                  </Typography>
                  <Box onClick={handleClick}>
                    <img
                      style={{ marginRight: '15px', marginTop: `${is1024 ? '15px' : '5px'}` }}
                      src={close}
                      alt="close icon"
                      width="14px"
                      height="14px"
                    />
                  </Box>
                </Box>
              )}
            </Grid>
            {completion && (
              <Grid item xs={12}>
                {/* Completion Information */}
                <Accordion
                  expanded={expanded === 'completion'}
                  onChange={handleAccordion('completion')}
                  sx={{ borderRadius: '20px', my: 2, boxShadow: 'none' }}
                >
                  <AccordionSummary
                    expandIcon={
                      expanded === 'completion' ? (
                        <Box sx={commonTextStyle.accordionButton}>
                          <RemoveIcon sx={{ color: colors.primary }} />
                        </Box>
                      ) : (
                        <Box sx={commonTextStyle.accordionButton}>
                          <AddIcon sx={{ color: colors.primary }} />
                        </Box>
                      )
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Grid item xs={9}>
                      <Typography sx={commonTextStyle.accordionStyle}>
                        Completion Information
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography sx={commonTextStyle.accordionCount}>
                        {completion?.progress?.completion?.complete
                          ? completion?.progress?.completion?.complete
                          : 0}{' '}
                        of{' '}
                        {completion?.progress?.completion?.total
                          ? completion?.progress?.completion?.total
                          : 2}{' '}
                        Completed
                      </Typography>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 1 of 2 <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Were there any adjustments to the program design or implementation?
                        </Typography>
                        <Typography sx={{...commonTextStyle.subHeading}}>
                          Please provide a brief explanation of any changes made to the
                          auto-populated information in this report. If no changes were made, please
                          type N/A.
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.labelStyle}>
                          Description
                          <Tooltip title="Description">
                            <InfoIcon
                              sx={{ marginLeft: '5px', fontSize: '15px', color: '#868e96' }}
                            />
                          </Tooltip>
                        </Typography>
                        <TextField
                          disabled
                          placeholder="No data yet"
                          fullWidth
                          value={completion && completion.completion?.adjustments}
                          variant="outlined"
                          multiline
                          rows={4}
                          sx={commonTextStyle.textAreaStyle}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 2 of 2 <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          What stories would you like to share from this program as a result of this
                          funding?
                        </Typography>
                        <Typography sx={{...commonTextStyle.subHeading}}>
                          If there are no stories you&apos;d like to share, please type N/A.
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.textFieldStyle}>
                          Description
                          <Tooltip title="Description">
                            <InfoIcon
                              sx={{ marginLeft: '5px', fontSize: '15px', color: '#868e96' }}
                            />
                          </Tooltip>
                        </Typography>
                        <TextField
                          disabled
                          placeholder="No data yet"
                          fullWidth
                          value={completion && completion.completion?.stories}
                          variant="outlined"
                          multiline
                          rows={4}
                          sx={commonTextStyle.textAreaStyle}
                        />
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* Funding information Accordion */}

                <Accordion
                  expanded={expanded === 'funding'}
                  onChange={handleAccordion('funding')}
                  sx={{ borderRadius: '20px', my: 2, boxShadow: 'none' }}
                >
                  <AccordionSummary
                    expandIcon={
                      expanded === 'funding' ? (
                        <Box sx={commonTextStyle.accordionButton}>
                          <RemoveIcon sx={{ color: colors.primary }} />
                        </Box>
                      ) : (
                        <Box sx={commonTextStyle.accordionButton}>
                          <AddIcon sx={{ color: colors.primary }} />
                        </Box>
                      )
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Grid item xs={9}>
                      <Typography sx={commonTextStyle.accordionStyle}>
                        Program Funding Information
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography sx={commonTextStyle.accordionCount}>
                        {completion?.progress?.funding?.complete
                          ? completion?.progress?.funding?.complete
                          : 0}{' '}
                        of{' '}
                        {completion?.progress?.funding?.total
                          ? completion?.progress?.funding?.total
                          : 3}{' '}
                        Completed
                      </Typography>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sx={{ marginBottom: '1rem' }}>
                        <Card
                          className="smallCards"
                          sx={{ borderColor: '#C4C4C4', boxShadow: 'none' }}
                        >
                          <Typography sx={commonTextStyle.questionStyle}>
                            Question 1 of 3
                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                          </Typography>
                          <Typography sx={commonTextStyle.heading}>
                            What are the start and end dates of this program?
                            <Tooltip title="Enter the start and end dates of this program">
                              <InfoIcon
                                sx={{ fontSize: '20px', color: '#868e96', marginLeft: '3px' }}
                              />
                            </Tooltip>
                          </Typography>
                          <Grid
                            container
                            sx={{
                              width: '100%',
                              margin: 0,
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <Grid item xs={12} sm={5} sx={{ marginBottom: '1rem' }}>
                              <Typography sx={commonTextStyle.labelStyle}>
                                Start Date
                                <Tooltip title="Start Date">
                                  <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                                </Tooltip>
                              </Typography>
                              <FormControl fullWidth margin="normal">
                                <DatePicker
                                  disabled
                                  value={completion?.funding?.programDate?.start}
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} variant="outlined" size="small" sx={commonTextStyle.textFieldStyle}/>
                                  )}
                                />
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={5} sx={{ marginBottom: '1rem' }}>
                              <Typography sx={commonTextStyle.labelStyle}>
                                End Date
                                <Tooltip title="End Date">
                                  <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                                </Tooltip>
                              </Typography>
                              <FormControl fullWidth margin="normal">
                                <DatePicker
                                  disabled
                                  value={completion?.funding?.programDate?.end}
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} variant="outlined" size="small" sx={commonTextStyle.textFieldStyle}/>
                                  )}
                                />
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>

                      {/* <Grid container spacing={2}> */}
                      <Grid item xs={12} sx={{ marginBottom: '1rem' }}>
                        <Card
                          className="smallCards"
                          sx={{ borderColor: '#C4C4C4', boxShadow: 'none' }}
                        >
                          <Typography sx={commonTextStyle.questionStyle}>
                            Question 2 of 3
                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                          </Typography>

                          <Typography
                            sx={commonTextStyle.heading}
                          >
                            Please specify the location where this funding will be applied.
                            <Tooltip title="Enter the location where this funding will be applied">
                              <InfoIcon
                                sx={{ fontSize: '20px', color: '#868e96', marginLeft: '3px' }}
                              />
                            </Tooltip>
                          </Typography>
                          <Grid item xs={12} sm={6} sx={{ marginBottom: '1rem' }}>
                            <Typography sx={commonTextStyle.labelStyle}>
                              Location Description
                              <Tooltip title="Location Description">
                                <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                              </Tooltip>
                            </Typography>
                            <TextField
                              disabled
                              placeholder="No data yet"
                              fullWidth
                              value={completion?.funding?.location?.value}
                              variant="outlined"
                              sx={commonTextStyle.textFieldStyle}
                            />
                          </Grid>
                        </Card>
                      </Grid>
                      {/* </Grid> */}
                      <Grid item xs={12} sx={{ marginBottom: '1rem' }}>
                        <Card
                          className="smallCards"
                          sx={{ borderColor: '#C4C4C4', boxShadow: 'none' }}
                        >
                          <Typography sx={commonTextStyle.questionStyle}>Question 3 of 3</Typography>

                          <Typography sx={commonTextStyle.heading}>How will this funding be used?</Typography>
                          <Typography sx={{...commonTextStyle.subHeading}}>
                            Please ensure itemization adds up to the total funding amount.
                          </Typography>
                          <TextField
                            disabled
                            placeholder="With normal TextField"
                            variant="outlined"
                            value={sumQuantity}
                            size="small"
                            sx={commonTextStyle.textFieldStyle}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Box
                                    sx={{
                                      backgroundColor: '#C4C4C4',
                                      height: '40px',
                                      width: '50px',
                                      lineHeight: '2',
                                      textAlign: 'center',
                                      marginLeft: '-14px',
                                      '.MuiOutlinedInput-notchedOutline': { border: 0 },
                                      'MuiInputBase-adornedStart': { paddingLeft: 0 },
                                    }}
                                  >
                                    $
                                  </Box>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <Typography sx={{...commonTextStyle.subHeading}}>
                            Of {getCurrencySymbol(fundingCurrency)}
                            {fundingAmount} Itemized
                          </Typography>
                          <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />

                          <Grid container direction="row" spacing={2} sx={{ marginTop: '4px' }}>
                            {completion?.funding?.itemization?.value.map((item, index: any) => (
                              <>
                                <Grid item xs={12} sm={4}>
                                  <Typography sx={commonTextStyle.labelStyle}>
                                    {`Item ${index + 1} Quantity`}{' '}
                                    <Tooltip title={`Enter item ${index + 1} quantity`}>
                                      <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                                    </Tooltip>
                                  </Typography>
                                  <TextField
                                    id={`quantity-${index}`}
                                    name={`quantity-${index}`}
                                    placeholder="Enter item quantity"
                                    value={item.quantity}
                                    variant="outlined"
                                    size="small"
                                    sx={{ ...commonTextStyle.textFieldStyle, width: '100%' }}
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <Box
                                            sx={{
                                              backgroundColor: '#C4C4C4',
                                              height: '40px',
                                              width: '50px',
                                              lineHeight: '2',
                                              textAlign: 'center',
                                              marginLeft: '-14px',
                                              '.MuiOutlinedInput-notchedOutline': { border: 0 },
                                              'MuiInputBase-adornedStart': { paddingLeft: 0 },
                                            }}
                                          >
                                            $
                                          </Box>
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <Typography sx={commonTextStyle.labelStyle}>
                                    {`Item ${index + 1} Description`}{' '}
                                    <Tooltip title={`Enter item ${index + 1} description`}>
                                      <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                                    </Tooltip>
                                  </Typography>
                                  <TextField
                                    name={`description-${index}`}
                                    placeholder="Enter item description"
                                    value={item.description}
                                    disabled
                                    fullWidth
                                    variant="outlined"
                                    sx={commonTextStyle.textFieldStyle}
                                  />
                                </Grid>
                              </>
                            ))}
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* General information Accordion */}
                <Accordion
                  expanded={expanded === 'general'}
                  onChange={handleAccordion('general')}
                  sx={{ borderRadius: '20px', my: 2, boxShadow: 'none' }}
                >
                  <AccordionSummary
                    expandIcon={
                      expanded === 'general' ? (
                        <Box sx={commonTextStyle.accordionButton}>
                          <RemoveIcon sx={{ color: colors.primary }} />
                        </Box>
                      ) : (
                        <Box sx={commonTextStyle.accordionButton}>
                          <AddIcon sx={{ color: colors.primary }} />
                        </Box>
                      )
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Grid item xs={9}>
                      <Typography sx={commonTextStyle.accordionStyle}>
                        General Information
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography sx={commonTextStyle.accordionCount}>
                        {completion?.progress?.general?.complete
                          ? completion?.progress?.general?.complete
                          : 0}{' '}
                        of{' '}
                        {completion?.progress?.general?.total
                          ? completion?.progress?.general?.total
                          : 6}{' '}
                        Completed
                      </Typography>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 1 of 3 <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Who will be the main contact person for this program?{' '}
                          <Tooltip title="Enter the details of main contact person for this program">
                            <InfoIcon
                              sx={{ fontSize: '20px', color: '#868e96', marginLeft: '3px' }}
                            />
                          </Tooltip>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography sx={commonTextStyle.labelStyle}>
                          First Name & Last Name
                        </Typography>
                        <TextField
                          disabled
                          placeholder="No data yet"
                          fullWidth
                          value={general?.contact?.name}
                          variant="outlined"
                          sx={commonTextStyle.textFieldStyle}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Typography sx={commonTextStyle.labelStyle}>
                          Email Address
                        </Typography>
                        <TextField
                          disabled
                          type="email"
                          placeholder="No data yet"
                          fullWidth
                          value={general?.contact?.email}
                          variant="outlined"
                          sx={commonTextStyle.textFieldStyle}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography sx={commonTextStyle.labelStyle}>
                          Phone Number
                        </Typography>
                        <TextField
                          disabled
                          placeholder="No data yet"
                          fullWidth
                          type="text"
                          value={general?.contact?.phone}
                          variant="outlined"
                          error={
                            general?.contact?.phone !== undefined &&
                            general?.contact?.phone!.length > 0 &&
                            (general?.contact?.phone![0] === '0' ||
                              general?.contact?.phone![0] === '1' ||
                              (general?.contact?.phone!.length < 10 &&
                                general?.contact?.phone !== ''))
                          }
                          InputProps={{
                            inputComponent: CellPhoneInput as any,
                          }}
                          sx={commonTextStyle.textFieldStyle}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 2 of 3 <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Please provide a name for this program.{' '}
                          <Tooltip title="Please provide a name for this program">
                            <InfoIcon
                              sx={{ fontSize: '20px', color: '#868e96', marginLeft: '3px' }}
                            />
                          </Tooltip>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography sx={commonTextStyle.labelStyle}>
                          Internal Program Name
                        </Typography>
                        <TextField
                          disabled
                          placeholder="No data yet"
                          fullWidth
                          value={general?.programName?.internalProgramName}
                          variant="outlined"
                          sx={commonTextStyle.textFieldStyle}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography sx={commonTextStyle.labelStyle}>
                          Platform Program name
                        </Typography>
                        <TextField
                          disabled
                          placeholder="No data yet"
                          fullWidth
                          value={general?.programName?.platformProgramName}
                          variant="outlined"
                          sx={commonTextStyle.textFieldStyle}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 3 of 3 <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Please provide a description of this program{' '}
                          <Tooltip title="Please provide a description of this program">
                            <InfoIcon
                              sx={{ fontSize: '20px', color: '#868e96', marginLeft: '3px' }}
                            />
                          </Tooltip>
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={commonTextStyle.labelStyle}>
                          Description
                        </Typography>
                        <TextField
                          disabled
                          placeholder="No data yet"
                          fullWidth
                          value={general?.programDescription?.description}
                          variant="outlined"
                          multiline
                          maxRows={4}
                          sx={commonTextStyle.textAreaStyle}
                        />
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* Impact and scope Accordion */}
                <Accordion
                  expanded={expanded === 'impact'}
                  onChange={handleAccordion('impact')}
                  sx={{ borderRadius: '20px', my: 2, boxShadow: 'none' }}
                >
                  <AccordionSummary
                    expandIcon={
                      expanded === 'impact' ? (
                        <Box sx={commonTextStyle.accordionButton}>
                          <RemoveIcon sx={{ color: colors.primary }} />
                        </Box>
                      ) : (
                        <Box sx={commonTextStyle.accordionButton}>
                          <AddIcon sx={{ color: colors.primary }} />
                        </Box>
                      )
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Grid item xs={9}>
                      <Typography sx={commonTextStyle.accordionStyle}>
                        Impact and Scope
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography sx={commonTextStyle.accordionCount}>
                        {completion?.progress?.impactAndScope?.complete
                          ? completion?.progress?.impactAndScope?.complete
                          : 0}{' '}
                        of{' '}
                        {completion?.progress?.impactAndScope?.total
                          ? completion?.progress?.impactAndScope?.total
                          : 5}{' '}
                        Completed
                      </Typography>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 1 of 12<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Which cause areas best match this program&apos;s work?
                        </Typography>
                        <Typography
                          sx={commonTextStyle.subHeading}
                        >
                          Please select up to two from the list below.
                        </Typography>
                      </Grid>
                      {
                        /* eslint no-underscore-dangle: 0 */
                        vocab?.causes.map((item: any) => (
                          <Grid key={item._id} item>
                            <Box
                              className={formValues.causes.includes(item._id) ? 'active' : ''}
                              sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                            >
                              <Typography variant="body1" display="inline">
                                {item.label}
                              </Typography>
                              <Checkbox
                                disabled
                                onChange={handleChangeSelect}
                                name="causes"
                                checked={formValues.causes.includes(item._id)}
                                value={item._id}
                              />
                            </Box>
                          </Grid>
                        ))
                      }
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 2 of 12<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          What is this program&apos;s primary targeted impact?
                        </Typography>
                        <Typography
                          sx={commonTextStyle.subHeading}
                        >
                          Impacts are long-term effects of your program. Please select one option
                          from the list below.
                        </Typography>
                      </Grid>
                      {vocab?.causes.map((item: any) => (
                        <Grid key={item._id} sx={{ my: 1 }} item xs={12}>
                          <Box sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}>
                            <Typography sx={commonTextStyle.heading}>
                              {item.label}
                            </Typography>
                            <br />
                            <Grid item xs={12}>
                              <FormControl>
                                <RadioGroup
                                  sx={{ display: 'inline-block' }}
                                  name="primaryImpact"
                                  value={formValues.primaryImpact}
                                  onChange={handleChange}
                                >
                                  {vocab?.impact.map((subitem: any) => {
                                    if (subitem.causeId === item._id) {
                                      return (
                                        <FormControlLabel
                                          sx={{
                                            p: 2,
                                            m: 1,
                                            border: '1px solid #E0E0E0',
                                            borderRadius: '20px',
                                          }}
                                          labelPlacement="start"
                                          key={subitem._id}
                                          value={subitem._id}
                                          control={<Radio disabled />}
                                          label={subitem.label}
                                        />
                                      );
                                    }
                                    return true;
                                  })}
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                          </Box>
                        </Grid>
                      ))}
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 3 of 12<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          What are the secondary impacts of this program?
                        </Typography>
                        <Typography
                          sx={commonTextStyle.subHeading}
                        >
                          Impacts are long-term effects of your program. Please select one option
                          from the list below.
                        </Typography>
                      </Grid>
                      {vocab?.impact.map((subItem: any) => {
                        if (subItem?.label === 'N/A') {
                          return (
                            <Grid item>
                              <Box
                                className={
                                  formValues.secondaryImpact.includes(subItem?._id) ? 'active' : ''
                                }
                                sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                              >
                                <Typography variant="body1" display="inline">
                                  N/A
                                </Typography>
                                <Checkbox
                                  name="secondaryImpact"
                                  checked={formValues.secondaryImpact.includes(subItem?._id)}
                                  value={subItem?._id}
                                  disabled
                                />
                              </Box>
                            </Grid>
                          );
                        }
                        return true;
                      })}
                      {vocab?.causes.map((item: any) => (
                        <Grid key={item._id} sx={{ my: 1 }} item xs={12}>
                          <Box sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}>
                            <Typography sx={commonTextStyle.heading}>
                              {item.label}
                            </Typography>
                            <br />
                            {vocab?.impact.map((subItem: any) => {
                              if (subItem.causeId === item._id) {
                                return (
                                  <Box
                                    key={subItem._id}
                                    className={
                                      formValues.secondaryImpact.includes(subItem._id)
                                        ? 'active'
                                        : ''
                                    }
                                    sx={{
                                      border: '1px solid #E0E0E0',
                                      display: 'inline-block',
                                      width: 'fit-content',
                                      m: 1,
                                      borderRadius: '20px',
                                      p: 2,
                                    }}
                                  >
                                    <Typography variant="body1" display="inline">
                                      {subItem.label}
                                    </Typography>
                                    <Checkbox
                                      onChange={handleChangeSelect}
                                      name="secondaryImpact"
                                      checked={formValues.secondaryImpact.includes(subItem._id)}
                                      value={subItem._id}
                                      disabled
                                    />
                                  </Box>
                                );
                              }
                              return true;
                            })}
                          </Box>
                        </Grid>
                      ))}
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 6 of 12<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Does this program specifically target any of the following groups of
                          people?
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{ marginBottom: '1.5rem', marginTop: '2px' }}
                        >
                          Please select all that apply.
                        </Typography>
                      </Grid>
                      {
                        /* eslint no-underscore-dangle: 0 */
                        vocab?.audience.attribute.map((item: any) => (
                          <Grid key={item._id} item>
                            <Box
                              className={formValues.targetGroup.includes(item._id) ? 'active' : ''}
                              sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                            >
                              <Typography variant="body1" display="inline">
                                {item.label}
                              </Typography>
                              <Checkbox
                                disabled
                                name="targetGroup"
                                checked={formValues.targetGroup.includes(item._id)}
                                value={item._id}
                                onChange={handleChangeSelect}
                              />
                            </Box>
                          </Grid>
                        ))
                      }
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 7 of 12<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          What age groups does this program serve?
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{ marginBottom: '1.5rem', marginTop: '2px' }}
                        >
                          Please select all that apply.
                        </Typography>
                      </Grid>
                      {
                        /* eslint no-underscore-dangle: 0 */
                        vocab?.audience.age.map((item: any) => (
                          <Grid key={item._id} item>
                            <Box
                              className={formValues.audienceAge.includes(item._id) ? 'active' : ''}
                              sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                            >
                              <Typography variant="body1" display="inline">
                                {item.label}
                              </Typography>
                              <Checkbox
                                name="audienceAge"
                                checked={formValues.audienceAge.includes(item._id)}
                                value={item._id}
                                disabled
                                onChange={handleChangeSelect}
                              />
                            </Box>
                          </Grid>
                        ))
                      }
                      {vocab && (
                        <Grid item>
                          <Box
                            className={formValues.audienceAge.includes('N/A') ? 'active' : ''}
                            sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                          >
                            <Typography variant="body1" display="inline">
                              N/A
                            </Typography>
                            <Checkbox
                              disabled
                              name="audienceAge"
                              checked={formValues.audienceAge.includes('N/A')}
                              value="N/A"
                              onChange={handleChangeSelect}
                            />
                          </Box>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 8 of 12<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          In which specific regions does this program operate?
                        </Typography>
                        <Typography
                          sx={commonTextStyle.subHeading}
                        >
                          Please select all that apply.
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} textAlign="center" sm={6}>
                            <Box
                              className={
                                formValues?.locationExplanation?.regions !== '' ? 'active' : ''
                              }
                              sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                            >
                              <Typography variant="body1" display="inline">
                                Able to operate in anywhere (please explain)
                              </Typography>
                              <Checkbox
                                name="regions"
                                disabled
                                checked={formValues?.locationExplanation?.regions !== ''}
                                value="N/A"
                                onChange={handleChangeSelect}
                              />
                            </Box>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            style={{
                              display:
                                formValues?.locationExplanation?.regions === ''
                                  ? 'none'
                                  : 'initial',
                            }}
                          >
                            <Typography sx={commonTextStyle.labelStyle}>Description</Typography>
                            <TextField
                              name="locationExplanation"
                              placeholder="Enter description here"
                              fullWidth
                              value={formValues?.locationExplanation?.regions}
                              disabled
                              variant="outlined"
                              multiline
                              rows={2}
                              sx={commonTextStyle.textAreaStyle}
                            />
                          </Grid>
                        </Grid>
                        <Grid sx={{ my: 2 }} item xs={12}>
                          <Box sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}>
                            <Typography sx={{ ...commonTextStyle.heading, my: 2 }} display="inline">
                              Regions
                            </Typography>
                            <br />
                            {locations?.continents.map((subItem: any) => (
                              <Box
                                key={subItem.name}
                                className={
                                  formValues.regions.includes(subItem.name) ? 'active' : ''
                                }
                                sx={{
                                  border: '1px solid #E0E0E0',
                                  display: 'inline-block',
                                  width: 'fit-content',
                                  m: 2,
                                  borderRadius: '20px',
                                  p: 2,
                                }}
                              >
                                <Typography variant="body1" display="inline">
                                  {subItem.name}
                                </Typography>
                                <Checkbox
                                  disabled
                                  name="regions"
                                  checked={formValues.regions.includes(subItem.name)}
                                  value={subItem.name}
                                  onChange={handleChangeSelect}
                                />
                              </Box>
                            ))}
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography sx={commonTextStyle.questionStyle}>
                            Question 9 of 12
                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                          </Typography>
                          <Typography sx={commonTextStyle.heading}>
                            In which specific countries does this program operate?
                          </Typography>
                          <Typography
                            variant="subtitle1"
                            sx={{ marginBottom: '1.5rem', marginTop: '2px' }}
                          >
                            Please select all that apply.
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} textAlign="center" sm={6}>
                              <Box
                                className={
                                  formValues?.locationExplanation?.countries !== '' ? 'active' : ''
                                }
                                sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                              >
                                <Typography variant="body1" display="inline">
                                  Not able to specify further (please explain)
                                </Typography>
                                <Checkbox
                                  name="countries"
                                  disabled
                                  checked={formValues?.locationExplanation?.countries !== ''}
                                  value="N/A"
                                  onChange={handleChangeSelect}
                                />
                              </Box>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              style={{
                                display:
                                  formValues?.locationExplanation?.countries === ''
                                    ? 'none'
                                    : 'initial',
                              }}
                            >
                              <Typography sx={commonTextStyle.labelStyle}>Description</Typography>
                              <TextField
                                name="locationExplanation"
                                placeholder="Enter description here"
                                fullWidth
                                value={formValues?.locationExplanation?.countries}
                                disabled
                                margin="normal"
                                variant="outlined"
                                multiline
                                rows={2}
                              />
                            </Grid>
                          </Grid>
                          {formValues.regions.map((item: string) => (
                            <Grid key={item} sx={{ my: 1 }} item xs={12}>
                              <Box sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}>
                                <Typography sx={{ my: 2, fontSize: fonts.fontSize18, fontWeight: fonts.fontWeight600 }} display="inline">
                                  {item}
                                </Typography>
                                <br />
                                {locations && renderCountries(item)}
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                        <Grid item xs={12}>
                          <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography sx={commonTextStyle.questionStyle}>
                            Question 10 of 12
                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                          </Typography>
                          <Typography sx={commonTextStyle.heading}>
                            In which specific states does this program operate?
                          </Typography>
                          <Typography
                            variant="subtitle1"
                            sx={{ marginBottom: '1.5rem', marginTop: '2px' }}
                          >
                            Please select all that apply.
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} textAlign="center" sm={6}>
                              <Box
                                className={
                                  formValues?.locationExplanation?.states !== '' ? 'active' : ''
                                }
                                sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                              >
                                <Typography variant="body1" display="inline">
                                  Able to operate in anywhere (please explain)
                                </Typography>
                                <Checkbox
                                  name="states"
                                  checked={formValues?.locationExplanation?.states !== ''}
                                  value="N/A"
                                  onChange={handleChangeSelect}
                                />
                              </Box>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              style={{
                                display:
                                  formValues?.locationExplanation?.states === ''
                                    ? 'none'
                                    : 'initial',
                              }}
                            >
                              <Typography sx={commonTextStyle.labelStyle}>Description</Typography>
                              <TextField
                                name="locationExplanation"
                                placeholder="Enter description here"
                                fullWidth
                                value={formValues?.locationExplanation?.states}
                                disabled
                                margin="normal"
                                variant="outlined"
                                multiline
                                rows={2}
                              />
                            </Grid>
                          </Grid>
                          {formValues.countries.map((item: string) => {
                            const n = item.lastIndexOf(';');
                            const result = item.substring(n + 1);
                            if (result === 'United States' || result === 'Canada') {
                              return (
                                <Grid key={result} sx={{ my: 1 }} item xs={12}>
                                  <Box
                                    sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                                  >
                                    <Typography sx={{ my: 2, fontSize: fonts.fontSize18, fontWeight: fonts.fontWeight600 }}  display="inline">
                                      {result}
                                    </Typography>
                                    <br />
                                    {locations && renderStates(result)}
                                  </Box>
                                </Grid>
                              );
                            }
                            return true;
                          })}
                        </Grid>
                        <Grid item xs={12}>
                          <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography sx={commonTextStyle.questionStyle}>
                            Question 11 of 12
                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                          </Typography>
                          <Typography sx={commonTextStyle.heading}>
                            In which specific cities does this program operate?
                          </Typography>
                          <Typography
                            variant="subtitle1"
                            sx={{ marginBottom: '1.5rem', marginTop: '2px' }}
                          >
                            Please select all that apply.
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} textAlign="center" sm={6}>
                              <Box
                                className={
                                  formValues?.locationExplanation?.cities !== '' ? 'active' : ''
                                }
                                sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                              >
                                <Typography variant="body1" display="inline">
                                  Able to operate in anywhere (please explain)
                                </Typography>
                                <Checkbox
                                  name="cities"
                                  disabled
                                  checked={formValues?.locationExplanation?.cities !== ''}
                                  value="N/A"
                                  onChange={handleChangeSelect}
                                />
                              </Box>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              style={{
                                display:
                                  formValues?.locationExplanation?.cities === ''
                                    ? 'none'
                                    : 'initial',
                              }}
                            >
                              <Typography sx={commonTextStyle.labelStyle}>Description</Typography>
                              <TextField
                                name="locationExplanation"
                                placeholder="Enter description here"
                                fullWidth
                                value={formValues?.locationExplanation?.cities}
                                disabled
                                margin="normal"
                                variant="outlined"
                                multiline
                                rows={2}
                              />
                            </Grid>
                          </Grid>
                          {formValues.countries.map((item: string) => {
                            const n = item.lastIndexOf(';');
                            const result = item.substring(n + 1);
                            if (result !== 'United States' && result !== 'Canada') {
                              return (
                                <Grid key={result} sx={{ my: 1 }} item xs={12}>
                                  <Box
                                    sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                                  >
                                    <Typography sx={{ my: 2, fontSize: fonts.fontSize18, fontWeight: fonts.fontWeight600 }} display="inline">
                                      {result}
                                    </Typography>
                                    <br />
                                    {locations && renderCities(result)}
                                  </Box>
                                </Grid>
                              );
                            }
                            return true;
                          })}
                        </Grid>
                        <Grid item xs={12}>
                          <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography sx={commonTextStyle.questionStyle}>
                            Question 12 of 12
                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                          </Typography>
                          <Typography sx={commonTextStyle.heading}>
                            Is there anything you&apos;d like to add about where your program
                            operates?{' '}
                            <Tooltip
                              title="Is there anything you'd like to add about where your program
                          operates"
                            >
                              <InfoIcon
                                sx={{ fontSize: '20px', color: '#868e96', marginLeft: '3px' }}
                              />
                            </Tooltip>
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography sx={commonTextStyle.labelStyle}>
                            Description
                          </Typography>
                          <TextField
                            name="additionalLocationDetails"
                            placeholder="Enter details"
                            disabled
                            fullWidth
                            value={formValues?.additionalLocationDetails}
                            onChange={handleChange}
                            variant="outlined"
                            multiline
                            rows={4}
                            sx={commonTextStyle.textAreaStyle}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* Strategies and Approaches */}
                <Accordion
                  expanded={expanded === 'strategies'}
                  onChange={handleAccordion('strategies')}
                  sx={{ borderRadius: '20px', my: 2, boxShadow: 'none' }}
                >
                  <AccordionSummary
                    expandIcon={
                      expanded === 'strategies' ? (
                        <Box sx={commonTextStyle.accordionButton}>
                          <RemoveIcon sx={{ color: colors.primary }} />
                        </Box>
                      ) : (
                        <Box sx={commonTextStyle.accordionButton}>
                          <AddIcon sx={{ color: colors.primary }} />
                        </Box>
                      )
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Grid item xs={9}>
                      <Typography sx={commonTextStyle.accordionStyle}>
                        Strategies and Approaches
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography sx={commonTextStyle.accordionCount}>
                        {completion?.progress?.strategiesAndApproaches?.complete
                          ? completion?.progress?.strategiesAndApproaches?.complete
                          : 0}{' '}
                        of{' '}
                        {completion?.progress?.strategiesAndApproaches?.total
                          ? completion?.progress?.strategiesAndApproaches?.total
                          : 7}{' '}
                        Completed
                      </Typography>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 1 of 8<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          How would you classify the strategies this program employs?
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{ marginBottom: '1.5rem', marginTop: '2px' }}
                        >
                          Please select all that apply.
                        </Typography>
                      </Grid>
                      {
                        /* eslint no-underscore-dangle: 0 */
                        vocab?.programApproach.map((item: any) => (
                          <Grid key={item._id} item>
                            <Box
                              className={formValues.strategies.includes(item._id) ? 'active' : ''}
                              sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                            >
                              <Typography variant="body1" display="inline">
                                {item.label}
                              </Typography>
                              <Checkbox
                                disabled
                                name="strategies"
                                checked={formValues.strategies.includes(item._id)}
                                value={item._id}
                                onChange={handleChangeSelect}
                              />
                            </Box>
                          </Grid>
                        ))
                      }
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 2 of 8<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Describe the specific activities you will undertake to implement your
                          program.{' '}
                          <Tooltip
                            title="Describe the specific activities you will undertake to implement your
                          program"
                          >
                            <InfoIcon
                              sx={{ fontSize: '20px', color: '#868e96', marginLeft: '3px' }}
                            />
                          </Tooltip>
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.labelStyle}>Description</Typography>
                        <TextField
                          name="activities"
                          placeholder="Enter activities in your program"
                          fullWidth
                          disabled
                          value={formValues.activities}
                          onChange={handleChange}
                          variant="outlined"
                          multiline
                          rows={4}
                          sx={commonTextStyle.textAreaStyle}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 3 of 8<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Is the program intervention one-time or ongoing?
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl>
                          <RadioGroup
                            sx={{ display: 'inline-block' }}
                            name="approachDuration"
                            value={formValues.approachDuration}
                            onChange={handleChange}
                          >
                            {vocab?.approachDuration.map((item: any) => (
                              <FormControlLabel
                                sx={{
                                  p: 2,
                                  mx: 2,
                                  border: '1px solid #E0E0E0',
                                  borderRadius: '20px',
                                }}
                                labelPlacement="start"
                                key={item._id}
                                value={item._id}
                                control={<Radio disabled />}
                                label={item.label}
                              />
                            ))}
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 4 of 8<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Describe the frequency and length of the program activities.{' '}
                          <Tooltip title="Describe the frequency and length of the program activities">
                            <InfoIcon
                              sx={{ fontSize: '20px', color: '#868e96', marginLeft: '3px' }}
                            />
                          </Tooltip>
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.labelStyle}>Description</Typography>
                        <TextField
                          name="activitiesFrequency"
                          placeholder="Enter length of program"
                          fullWidth
                          disabled
                          value={formValues.activitiesFrequency}
                          onChange={handleChange}
                          variant="outlined"
                          multiline
                          rows={4}
                          sx={commonTextStyle.textAreaStyle}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 5 of 8<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>What outputs does this program create?</Typography>
                        <Typography
                          sx={commonTextStyle.subHeading}
                        >
                          {`These outputs should be based on the $${Number(
                            fundingAmount && fundingAmount,
                          ).toFixed(2)} funding amount provided by this opportunity.`}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        {formValues?.outputs?.map((lifetimeOutput: any, index) => (
                          <Grid container spacing={4} key={lifetimeOutput.key}>
                            <Grid item xs={12} sm={2} mb={2}>
                              <Typography sx={commonTextStyle.labelStyle}>
                                Outcome % <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                              </Typography>
                              <TextField
                                disabled
                                name="quantity"
                                type="number"
                                value={lifetimeOutput.quantity}
                                onChange={handleOutputChange('quantity', index, 'outputs')}
                                variant="outlined"
                                className="inputTextFiled"
                                fullWidth
                                sx={commonTextStyle.textFieldStyle}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} mb={2}>
                              <Typography sx={commonTextStyle.labelStyle}>
                                Outcome{' '}
                                <Tooltip title="Enter program outputs">
                                  <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                                </Tooltip>
                              </Typography>
                              <TextField
                                disabled
                                name="description"
                                type="text"
                                value={lifetimeOutput.description}
                                onChange={handleOutputChange('description', index, 'outputs')}
                                sx={commonTextStyle.textFieldStyle}
                                variant="outlined"
                                className="inputTextFiled"
                                fullWidth
                              />
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>Question 6 of 8</Typography>
                        <Typography sx={commonTextStyle.heading}>
                          What outcomes does this program create?
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{ marginBottom: '1.5rem', marginTop: '2px' }}
                        >
                          Outcomes show the effectiveness of your program.
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        {formValues?.outcomes?.map((lifetimeOutput: any, index) => (
                          <Grid container spacing={4} key={lifetimeOutput.key}>
                            <Grid item xs={12} sm={2} mb={2}>
                              <Typography sx={commonTextStyle.labelStyle}>
                                Outcome % <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                              </Typography>
                              <TextField
                                disabled
                                name="quantity"
                                type="number"
                                value={lifetimeOutput.quantity}
                                onChange={handleOutputChange('quantity', index, 'outcomes')}
                                variant="outlined"
                                className="inputTextFiled"
                                fullWidth
                                sx={commonTextStyle.textFieldStyle}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} mb={2}>
                              <Typography sx={commonTextStyle.labelStyle}>
                                Outcome{' '}
                                <Tooltip title="Enter program outputs">
                                  <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                                </Tooltip>
                              </Typography>
                              <TextField
                                disabled
                                name="description"
                                type="text"
                                value={lifetimeOutput.description}
                                onChange={handleOutputChange('description', index, 'outcomes')}
                                InputProps={{
                                  sx: {
                                    '& .MuiInputBase-input::placeholder': {
                                      fontSize: '1rem',
                                    },
                                  },
                                }}
                                sx={commonTextStyle.textFieldStyle}
                                variant="outlined"
                                fullWidth
                              />
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 7 of 8<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Are your results measured qualitatively or quantitatively?
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl>
                          <RadioGroup
                            sx={{ display: 'inline-block' }}
                            name="dataMeasurementType"
                            value={formValues.dataMeasurementType}
                            onChange={handleChange}
                          >
                            {vocab?.dataMeasurement.map((item: any) => (
                              <FormControlLabel
                                sx={{
                                  p: 2,
                                  mx: 2,
                                  border: '1px solid #E0E0E0',
                                  borderRadius: '20px',
                                }}
                                labelPlacement="start"
                                key={item._id}
                                value={item._id}
                                control={<Radio disabled />}
                                label={item.label}
                              />
                            ))}
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 8 of 8<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Are there any SIO partners supporting this program?
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <FormControl>
                          <RadioGroup
                            sx={{ display: 'inline-block' }}
                            name="nonprofitPartners"
                            value={formValues.nonprofitPartners ? 'yes' : 'no'}
                            onChange={handleChange}
                          >
                            <FormControlLabel
                              sx={{
                                p: 2,
                                mx: 2,
                                border: '1px solid #E0E0E0',
                                borderRadius: '20px',
                              }}
                              value="yes"
                              control={<Radio disabled />}
                              label="Yes"
                            />
                            <FormControlLabel
                              sx={{
                                p: 2,
                                mx: 2,
                                border: '1px solid #E0E0E0',
                                borderRadius: '20px',
                              }}
                              value="no"
                              control={<Radio disabled />}
                              label="No"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      {formValues.nonprofitPartners && (
                        <Grid item xs={12} sm={6}>
                          <Typography sx={commonTextStyle.labelStyle}>
                            SIO partners{' '}
                            <Tooltip title="Please mention all SIO partners supporting this program">
                              <InfoIcon sx={{ fontSize: '15px', color: '#868e96' }} />
                            </Tooltip>
                          </Typography>
                          <TextField
                            name="nonprofitPartnersDescription"
                            placeholder="Please mention all SIO partners supporting this program."
                            fullWidth
                            disabled
                            value={formValues?.nonprofitPartnersDescription?.trim()}
                            onChange={handleChange}
                            variant="outlined"
                            multiline
                            sx={commonTextStyle.textAreaStyle}
                            rows={2}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* Research and Evaluation */}
                <Accordion
                  expanded={expanded === 'research'}
                  onChange={handleAccordion('research')}
                  sx={{ borderRadius: '20px', my: 2, boxShadow: 'none' }}
                >
                  <AccordionSummary
                    expandIcon={
                      expanded === 'research' ? (
                        <Box sx={commonTextStyle.accordionButton}>
                        <RemoveIcon sx={{ color: colors.primary }} />
                      </Box>
                    ) : (
                      <Box sx={commonTextStyle.accordionButton}>
                        <AddIcon sx={{ color: colors.primary }} />
                      </Box>
                    )
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Grid item xs={9}>
                      <Typography sx={commonTextStyle.accordionStyle}>
                        Research and Evaluation
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography sx={commonTextStyle.accordionCount}>
                        {completion?.progress?.researchAndEvaluation?.complete
                          ? completion?.progress?.researchAndEvaluation?.complete
                          : 0}{' '}
                        of{' '}
                        {completion?.progress?.researchAndEvaluation?.total
                          ? completion?.progress?.researchAndEvaluation?.total
                          : 2}{' '}
                        Completed
                      </Typography>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>Question 1 of 9</Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Please upload the research or evaluation that informs your program design.
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          name="researchFile"
                          placeholder="Select File"
                          fullWidth
                          type="file"
                          disabled
                          // value={formValues.researchFile.name}
                          onChange={handleUpload}
                          variant="outlined"
                          sx={commonTextStyle.textFieldStyle}
                        />
                        {formValues.researchFile && (
                          <Grid item xs={12}>
                            <Typography variant="body1" sx={{ lineHeight: '19.36px', display: 'flex', alignItems: 'center' }}>
                              <b style={{ marginRight: '4px'}}>File Name: </b> {formValues.researchFile.name}
                              {formValues.researchFile.name && downloadTextButton(formValues.researchFile)}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 2 of 9<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          How would you describe the evidence or data?
                        </Typography>
                        <Grid xs={7}>
                          <Typography
                            sx={commonTextStyle.subHeading}
                          >
                            Please note, this information helps us derive additional value your
                            organization is creating through the use of methods that have been
                            researched and evaluated. This should be program-specific, not at an
                            organization level.
                          </Typography>
                        </Grid>
                      </Grid>
                      {
                        /* eslint no-underscore-dangle: 0 */
                        vocab?.studyEvidenceType.map((item: any) => (
                          <Grid key={item._id} item>
                            <Box
                              className={
                                formValues.evidenceDescription.includes(item._id) ? 'active' : ''
                              }
                              sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                            >
                              <Typography variant="body1" display="inline">
                                {item.label}
                              </Typography>
                              <Checkbox
                                disabled
                                name="evidenceDescription"
                                checked={formValues.evidenceDescription.includes(item._id)}
                                value={item._id}
                                onChange={handleChangeSelect}
                              />
                            </Box>
                          </Grid>
                        ))
                      }
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 3 of 9<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          How would you describe the study design?
                        </Typography>
                        <Typography
                          sx={commonTextStyle.subHeading}
                        >
                          Please select all that apply.
                        </Typography>
                      </Grid>
                      {
                        /* eslint no-underscore-dangle: 0 */
                        vocab?.studyDesignType.map((item: any) => (
                          <Grid key={item._id} item>
                            <Box
                              className={
                                formValues.studyDescription.includes(item._id) ? 'active' : ''
                              }
                              sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                            >
                              <Typography variant="body1" display="inline">
                                {item.label}
                              </Typography>
                              <Checkbox
                                disabled
                                name="studyDescription"
                                checked={formValues.studyDescription.includes(item._id)}
                                value={item._id}
                                onChange={handleChangeSelect}
                              />
                            </Box>
                          </Grid>
                        ))
                      }
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 4 of 9 <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          How would you describe the data in the study?
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{ marginBottom: '1.5rem', marginTop: '2px' }}
                        >
                          Please select all that apply.
                        </Typography>
                      </Grid>
                      {
                        /* eslint no-underscore-dangle: 0 */
                        vocab?.researchDataType.map((item: any) => (
                          <Grid key={item._id} item>
                            <Box
                              className={
                                formValues.dataDescription.includes(item._id) ? 'active' : ''
                              }
                              sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                            >
                              <Typography variant="body1" display="inline">
                                {item.label}
                              </Typography>
                              <Checkbox
                                disabled
                                name="dataDescription"
                                checked={formValues.dataDescription.includes(item._id)}
                                value={item._id}
                                onChange={handleChangeSelect}
                              />
                            </Box>
                          </Grid>
                        ))
                      }
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 5 of 9 <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          How would you describe the correlation of your program to your outcomes
                          based on the study?
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl>
                          <RadioGroup
                            sx={{ display: 'inline-block' }}
                            name="outcomeDescription"
                            value={formValues.outcomeDescription}
                            onChange={handleChange}
                          >
                            {vocab?.effect.map((item: any) => (
                              <FormControlLabel
                                sx={{
                                  p: 2,
                                  mx: 2,
                                  border: '1px solid #E0E0E0',
                                  borderRadius: '20px',
                                }}
                                labelPlacement="start"
                                key={item._id}
                                value={item._id}
                                control={<Radio disabled />}
                                label={item.label}
                              />
                            ))}
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 6 of 9 <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Which strategies and approaches align with the research or evaluation this
                          program design is based on?
                        </Typography>
                        <Typography
                          sx={commonTextStyle.subHeading}
                        >
                          Please select at lease one, and up to three.
                        </Typography>
                      </Grid>
                      {vocab?.causes.map((item: any) => (
                        <Grid key={item._id} sx={{ my: 2 }} item xs={12}>
                          <Box
                            className={
                              formValues.evidenceDescription.includes(item._id) ? 'active' : ''
                            }
                            sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                          >
                            <Typography sx={commonTextStyle.heading}>
                              {item.label}
                            </Typography>
                            <br />
                            {vocab?.approach.map((subItem: any) => {
                              if (subItem.causeId === item._id) {
                                return (
                                  <Box
                                    key={subItem._id}
                                    className={
                                      isChecked1(subItem._id) ||
                                      formValues.researchApproach.includes(subItem._id)
                                        ? 'active'
                                        : ''
                                    }
                                    sx={{
                                      border: '1px solid #E0E0E0',
                                      display: 'inline-block',
                                      width: 'fit-content',
                                      m: 2,
                                      borderRadius: '20px',
                                      p: 2,
                                    }}
                                  >
                                    <Typography variant="body1" display="inline">
                                      {subItem.label}
                                    </Typography>
                                    <Checkbox
                                      disabled
                                      name="researchApproach"
                                      checked={
                                        isChecked1(subItem._id) ||
                                        formValues.researchApproach.includes(subItem._id)
                                      }
                                      value={subItem._id}
                                      onChange={handleChangeSelect}
                                    />
                                  </Box>
                                );
                              }
                              return true;
                            })}
                          </Box>
                        </Grid>
                      ))}
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 7 of 9 <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          What environmental outputs does this program create?
                        </Typography>
                        <Grid xs={7}>
                          <Typography
                            sx={commonTextStyle.subHeading}
                          >
                            The question was added because you selected a environmental strategies
                            and approaches. Please select all that apply.
                          </Typography>
                        </Grid>
                      </Grid>
                      {
                        /* eslint no-underscore-dangle: 0 */
                        vocab?.sccConversion.map((item: any) => (
                          <Grid key={item._id} item>
                            <Box
                              className={
                                formValues.environmentalOutputs.includes(item._id) ? 'active' : ''
                              }
                              sx={{ border: '1px solid #E0E0E0', borderRadius: '20px', p: 2 }}
                            >
                              <Typography variant="body1" display="inline">
                                {item.label}
                              </Typography>
                              <Checkbox
                                disabled
                                name="environmentalOutputs"
                                checked={formValues.environmentalOutputs.includes(item._id)}
                                value={item._id}
                                onChange={handleChangeSelect}
                              />
                            </Box>
                          </Grid>
                        ))
                      }
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 8 of 9 <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          Please add numeric values for the environmental outputs this program
                          creates.
                        </Typography>
                        <Typography
                          sx={commonTextStyle.subHeading}
                        >
                          Outputs are purely numberic values that are proportionate to your budget.
                          If your program was completely funded, these would be the metrics you
                          report.
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        {formValues?.environmentalOutputs?.map((lifetimeOutput: any, index) =>{
                          const label:any=vocab?.sccConversion?.filter((item:any)=>item?._id===lifetimeOutput)
 return (
   <Grid container spacing={4} key={lifetimeOutput}>
     <Grid item xs={12} sm={2} mb={2}>
       <Typography sx={commonTextStyle.labelStyle}>Quantity {index + 1}</Typography>
       <TextField
         value={getFieldValue(index, 'quantity')}
         disabled
         name="quantity"
         type="number"
         onChange={(event)=>{handleLifetimeOutputChange('quantity', index,event.target.value,lifetimeOutput)}}
         variant="outlined"
         className="inputTextFiled"
         fullWidth
         sx={commonTextStyle.textFieldStyle}
       />
     </Grid>
     <Grid item xs={12} sm={6} mb={2}>
       <Typography sx={commonTextStyle.labelStyle}>Output {index + 1} Description</Typography>
       <TextField
         disabled
         name="description"
         value={getFieldValue(index, 'description')}
         type="text"
         onChange={()=>{handleLifetimeOutputChange('description', index, label && label[0]?.label!,lifetimeOutputForm)}}
         sx={commonTextStyle.textFieldStyle}
         variant="outlined"
         className="inputTextFiled"
         fullWidth
       />
     </Grid>
   </Grid>
 );
                        } 
                        
                       )}
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} orientation="horizontal" flexItem />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={commonTextStyle.questionStyle}>
                          Question 9 of 9 <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </Typography>
                        <Typography sx={commonTextStyle.heading}>
                          How strong is the relation of the outcomes from the study to the
                          strategies and approaches you identified?
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl>
                          <RadioGroup
                            sx={{ display: 'inline-block' }}
                            name="strength"
                            value={formValues.strength}
                            onChange={handleChange}
                          >
                            {vocab?.strength.map((item: any) => (
                              <FormControlLabel
                                sx={{
                                  p: 2,
                                  mx: 2,
                                  border: '1px solid #E0E0E0',
                                  borderRadius: '20px',
                                }}
                                labelPlacement="start"
                                key={item._id}
                                value={item._id}
                                control={<Radio disabled />}
                                label={item.label}
                              />
                            ))}
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            )}
          </Grid>
        </Box>
      </Box>
      <Box sx={{ bgcolor: 'white', height: '100px' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} textAlign="right">
            {renderButtons()}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default CompletionDetails;